import type { TerritoryRecord } from '@clim/domain';
import { useState } from 'react';
import { ErrorBox, Field, Input } from '../../components/ui';
import { useApi, useMutation } from './common';

export function TerritoriesAdmin() {
  const { data, error, reload } = useApi<TerritoryRecord[]>('/v1/territories');
  const m = useMutation();
  const [f, setF] = useState({ code: '', name: '', timezone: 'America/', prefixes: '', dialCode: '', vatRate: '8.5' });
  const create = async () => {
    await m.run('POST', '/v1/admin/territories', {
      code: f.code,
      name: f.name,
      timezone: f.timezone,
      settings: {
        postalCodePrefixes: f.prefixes ? f.prefixes.split(',').map((s) => s.trim()) : undefined,
        dialCode: f.dialCode || undefined,
        vatRate: f.vatRate ? Number(f.vatRate) : undefined,
      },
    });
    setF({ code: '', name: '', timezone: 'America/', prefixes: '', dialCode: '', vatRate: '8.5' });
    reload();
  };
  return (
    <div>
      <ErrorBox message={error ?? m.error} />
      <table className="table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Nom</th>
            <th>Fuseau</th>
            <th>CP</th>
            <th>Actif</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((t) => (
            <tr key={t.id}>
              <td>{t.code}</td>
              <td>{t.name}</td>
              <td>{t.timezone}</td>
              <td>{((t.settings.postalCodePrefixes as string[] | undefined) ?? []).join(', ')}</td>
              <td>
                <input
                  type="checkbox"
                  checked={t.isActive}
                  onChange={() => void m.run('PATCH', `/v1/admin/territories/${t.id}`, { isActive: !t.isActive }).then(reload)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <h2>Ajouter un territoire</h2>
      <div className="card form">
        <div className="grid3">
          <Field label="Code">
            <Input value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.toUpperCase() })} placeholder="GF" />
          </Field>
          <Field label="Nom">
            <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Guyane" />
          </Field>
          <Field label="Fuseau horaire">
            <Input value={f.timezone} onChange={(e) => setF({ ...f, timezone: e.target.value })} />
          </Field>
        </div>
        <div className="grid3">
          <Field label="Préfixes code postal" hint="séparés par des virgules">
            <Input value={f.prefixes} onChange={(e) => setF({ ...f, prefixes: e.target.value })} placeholder="973" />
          </Field>
          <Field label="Indicatif">
            <Input value={f.dialCode} onChange={(e) => setF({ ...f, dialCode: e.target.value })} placeholder="+594" />
          </Field>
          <Field label="TVA par défaut (%)">
            <Input value={f.vatRate} onChange={(e) => setF({ ...f, vatRate: e.target.value })} inputMode="decimal" />
          </Field>
        </div>
        <button className="btn primary" onClick={() => void create()} disabled={!f.code || !f.name}>
          Ajouter
        </button>
      </div>
    </div>
  );
}
